module.exports = __webpack_public_path__ + "media/images/icon_item_paused-a342ce640e993c96dc5445e4406db399.png";